var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',[_c('mdb-pie-chart',{attrs:{"datalabels":"","data":_vm.pieChartData,"options":_vm.pieChartOptions,"width":500,"height":320}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }